import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import base64 from 'base-64';
import utf8 from 'utf8';
import { baseUrl } from '../../utils/api';

const string = `${process.env.REACT_APP_SMS_USERNAME}:${(process.env.REACT_APP_SMS_PASSWORD).replace(/\\/g, '')}`;
const bytes = utf8.encode(string);
const credentials = base64.encode(bytes);

export const apiBasePath = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json; charset=utf-8');
      headers.set('Accept', 'application/json');
      headers.set('Authorization', `Basic ${credentials} `);
      return headers;
    },
  }),
  endpoints: () => ({}),
});
